import {get} from 'lodash';
import {
    SHIP_PACK_ROUTE,
    SHIP_DETAILS_ROUTE,
    SHIP_PICKING_ROUTE,
    SHIP_PACKING_ROUTE,
} from '../../../modules/fulfillment/consts';
import { ORDERS_DETAILS_ROUTE } from '../../../modules/orders/consts';
import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';
import { SHIPMENT_DETAILS_ROUTE, SHIPMENT_PRINT_ROUTE } from '../../../modules/shipment/consts';

import UserModel from '../../../../UserModel';

const customFormProps = (props, details) => {
    const isVanEU = get(details, 'relatedOrder.customValues.website_code') === 'the_van_eu';

    if (isVanEU && get(details, 'is_international', false)) {
        return {
            ...props,
            validationSchema: {
                ...(props?.validationSchema || {}),
                international: {
                    ...(props?.validationSchema?.international || {}),
                    fields: {
                        customs_info: {
                            type: 'object',
                            fields: {
                                eel_pfc: {},
                                customs_signer: {},
                                contents_type: {},
                                contents_explanation: {},
                                restriction_type: {},
                                non_delivery_option: {},
                            },
                        },
                        incoterm: {},
                        tax_identifiers: {
                            type: 'object',
                            fields: {
                                SENDER: {
                                    type: 'object',
                                    fields: {
                                        tax_id: {},
                                        tax_id_type: {},
                                        issuing_country: {},
                                    },
                                },
                                RECEIVER: {
                                    ...(props?.validationSchema?.international?.fields?.tax_identifiers?.fields?.RECEIVER ||
                                        {}),
                                },
                            },
                        },
                    },
                },
            },
            initialValues: {
                ...(props?.initialValues || {}),
                international: {
                    customs_info: {
                        eel_pfc: '',
                        customs_signer: '',
                        contents_type: '',
                        contents_explanation: '',
                        restriction_type: '',
                        non_delivery_option: '',
                    },
                    incoterm: '',
                    tax_identifiers: {
                        SENDER: {
                            tax_id: '',
                            tax_id_type: '',
                            issuing_country: '',
                        },
                        RECEIVER: {
                            tax_id: '',
                            tax_id_type: '',
                            issuing_country: '',
                        },
                    },
                },
            },
        };
    }
    return props;
};

const customFormSections = (fields, details) => {
    const isVanEU = get(details, 'relatedOrder.customValues.website_code') === 'the_van_eu';

    if (isVanEU && get(details, 'is_international', false)) {
        const removeAsteriskFromFields = (fields = []) =>
            fields.map((item) => ({
                ...item,
                label: (item?.label || '').replace(/\*/g, '').trim(),
            }));

        return fields.map(({ fields: subFields = [], ...field }) => ({
            ...field,
            fields: subFields.map((subField = {}) => {
                const { name, extraProps = {} } = subField;

                if (name === 'international') {
                    return {
                        ...subField,
                        extraProps: {
                            ...extraProps,
                            baseFields: removeAsteriskFromFields(extraProps?.baseFields || []),
                            taxReceiverFields: removeAsteriskFromFields(extraProps?.taxReceiverFields || []),
                            taxSenderFields: removeAsteriskFromFields(extraProps?.taxSenderFields || []),
                        },
                    };
                }

                return subField;
            }),
        }));
    }

    return fields;
};

export default {
    name: 'shipFulfillmentPackingPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'fulfillmentShipPacking';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;
            route.props = (state) => ({
                ...routeProps(state),
                routes: {
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                    orderDetailsPageRoute: ORDERS_DETAILS_ROUTE,
                    pickingPageRoute: SHIP_PICKING_ROUTE,
                    packingPageRoute: SHIP_PACKING_ROUTE,
                    packPageRoute: SHIP_PACK_ROUTE,
                    detailsPageRoute: SHIP_DETAILS_ROUTE,
                    shipmentDetailsPageRoute: SHIPMENT_DETAILS_ROUTE,
                    shipmentPrintPageRoute: SHIPMENT_PRINT_ROUTE,
                },
                currentUserId: UserModel.getUserId(),
                showItemsImages: true,
                itemsHideUntilParcelSelected: false,
                withManualQuantity: false,
                withScanQtySelect: false,
                permissions: {
                    canAssignUser: true,
                    canUnassignUser: true,
                    canCancel: true,
                    withProductDetailsLink: true,
                    withOrderDetailsLink: true,
                },
                customFormProps,
                customFormSections,
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
